import React from 'react';

import { Typography } from '@metarouter-private/mr-mui';

import determineIntegrationStatus from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/determineIntegrationStatus';
import INTEGRATION_STATUS from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/INTEGRATION_STATUS';

const STATUS_DISPLAY = {
  [INTEGRATION_STATUS.CLI_MANAGED]: { message: 'CLI Managed (Active)', italic: true },
  [INTEGRATION_STATUS.STAGED_FOR_DELETE_ACTIVE]: { message: 'Staged for delete (Active)', italic: true },
  [INTEGRATION_STATUS.STAGED_FOR_DELETE_PAUSED]: { message: 'Staged for delete (Paused)', italic: true },
  [INTEGRATION_STATUS.NOT_DEPLOYED]: { message: 'Not deployed' },
  [INTEGRATION_STATUS.STAGED_FOR_PAUSE]: { message: 'Staged for pause', italic: true },
  [INTEGRATION_STATUS.STAGED_FOR_ACTIVATION]: { message: 'Staged for activation', italic: true },
  [INTEGRATION_STATUS.PAUSED]: { message: 'Paused' },
  [INTEGRATION_STATUS.ACTIVE]: { message: 'Active' },
};

export default function StatusCell(integrationRow) {
  const { message, italic } = STATUS_DISPLAY[determineIntegrationStatus(integrationRow)];

  return (
    <Typography variant="body2" italic={italic}>
      {message}
    </Typography>
  );
}
